<template>
  <div>
    <div id="branch-details-page" class="viewport viewport-with-top-nav viewport-compact">
      <TopNav></TopNav>

      <div class="display-1 mb-3">{{ branch.title }}</div>
      <div v-if="branch.hasAtm" class="mt-2 mb-4">
        <span id="badge-cash-withdrawal" class="badge badge-primary badge-pill badge-lg">{{ $t('BranchDetailsPage.cashWithdrawal') }}</span>
      </div>
      <p id="branch-address">
        {{ branch.streetAddress }}<br>
        <a :href="branch.mapUrl" v-if="branch.mapUrl">{{ $t('BranchDetailsPage.viewOnMap') }}</a>
      </p>
      <div class="row">
        <div id="branch-business-hours" class="col-12 mb-3">
          <div class="small text-muted">{{ $t('BranchDetailsPage.businessHours') }}</div>
          <div v-html="branch.openingTimes"></div>
        </div>
      </div>

      <div class="row">
        <div id="branch-phone" class="col-6 mb-3">
          <div class="small text-muted">{{ $t('BranchDetailsPage.phone') }}</div>
          <div><a :href="'tel:' + branch.phone">{{ branch.phone }}</a></div>
        </div>
        <div id="branch-email" class="col-6 mb-3">
          <div class="small text-muted">{{ $t('BranchDetailsPage.email') }}</div>
          <div><a :href="'mailto:' + branch.email">{{ branch.email }}</a></div>
        </div>
      </div>

      <div class="flex-grow-1"></div>

    <slot/>
    </div>
  </div>
</template>

<script>

import TopNav from '@shared/components/TopNav'
import BranchesMixin from '@shared/mixins/BranchesMixin'

export default {
  name: 'BranchDetailsPage',
  components: { TopNav },
  mixins: [BranchesMixin],
  props: {
    id: String
  },
  data() {
    return {
      branch: this.getBranchById(this.id)
    }
  }
}
</script>
